import { useState, useEffect } from "react";

import { apiUrl, getValFromLS, setValToLS } from "./utils";

import Alert from "./Alert";
import Msg from "./Msg";

import ReviewTable from "./ReviewTable";
import ReviewFormAndIframe from "./ReviewFormAndIframe";

import S from "./review-styled";
import {
	Table,
	Form,
	FormRow1,
	FormRow2,
	FormRow3,
	FormMsgSubmit,
} from "./styled";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-light-svg-icons";

S.Table = Table;
S.Form = Form;
S.FormRow1 = FormRow1;
S.FormRow2 = FormRow2;
S.FormRow3 = FormRow3;
S.FormMsgSubmit = FormMsgSubmit;

const Review = ({ started, submitted, brand }) => {
	const [items, setItems] = useState([]);
	const [totals, setTotals] = useState({
		subtotal: 0,
		tax: 0,
		tip: 0,
		total: 0,
	});
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});

	const API_URL = apiUrl();

	useEffect(() => {
		//window.scrollTo(0, 0);
		if (
			getValFromLS(`${brand}order`, true) &&
			getValFromLS(`${brand}authnet`, true)
		) {
			const array = JSON.parse(getValFromLS(`${brand}order`, true)).items;
			const contact = JSON.parse(getValFromLS(`${brand}order`, true)).contact;
			const authnet = JSON.parse(getValFromLS(`${brand}authnet`, true));
			let total = 0;
			array.forEach((item) => {
				const subtotal = item.qty * item.amt;
				total = total + subtotal;
			});
			const subtotal = total;
			const tax = 0;
			const tip = 0;
			total = subtotal + tax + tip;
			setTotals({
				subtotal,
				tax,
				tip,
				total,
			});
			setItems(array);
			setNames({ ...authnet, ...contact });
		} else {
			started(0);
		}
		// eslint-disable-next-line
	}, []);

	const handleRemove = (index) => {
		let array = items;
		array.splice(index, 1);
		let total = 0;
		array.forEach((item) => {
			const subtotal = item.qty * item.amt;
			total = total + subtotal;
		});
		const subtotal = total;
		const tax = 0;
		//const tip = names.gratuity ? Number(names.gratuity) * subtotal : 0;
		const tip = 0;
		total = subtotal + tax + tip;
		setTotals({
			subtotal,
			tax,
			tip,
			total,
		});
		setItems([...array]);
		setValToLS(
			`${brand}order`,
			JSON.stringify({
				items: array,
				contact: {
					fname: names.fname,
					lname: names.lname,
					email: names.email,
					phone: names.phone,
				},
			}),
			true
		);
	};

	/*const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value ? value : "" }));
	};*/

	const handleSuccess = async () => {
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/submit`);
		let formData = new FormData();
		formData.append("order", getValFromLS(`${brand}order`, true) || "");
		formData.append("totalAmt", totals.total || 0);
		formData.append("tipAmt", totals.tip || 0);
		formData.append("taxAmt", totals.tax || 0);
		formData.append("guestId", names.customer_id); // from authnet object after POST /order

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setValToLS(`${brand}order`, null, true);
				setValToLS(`${brand}authnet`, null, true);
				setValToLS("receipt", JSON.stringify(json.receipt), true);
				setMsg({});
				submitted(json.receipt.orderId);
			} else {
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<div>
			<>
				<h3
					style={{
						fontSize: "1.5rem",
						marginBottom: "15px",
						textTransform: "initial",
					}}
				>
					Please review your order and enter your billing information below to
					submit your order.
				</h3>

				<S.BackContainer data-brand={brand}>
					<button type="button" onClick={() => started(0)}>
						<div>
							<FontAwesomeIcon icon={faChevronLeft} size="lg" />
							<span>Back to Order</span>
						</div>
					</button>
				</S.BackContainer>

				{items.length === 0 ? (
					<div style={{ marginTop: "20px" }}>
						<Alert
							data={{
								type: "error",
								text: "There are no items in your order.",
							}}
						/>
					</div>
				) : (
					<>
						<ReviewTable
							items={items}
							handleRemove={handleRemove}
							totals={totals}
						/>

						{msg.type ? (
							<S.LoadingContainer>
								<Msg data={msg} />
							</S.LoadingContainer>
						) : names.token ? (
							<ReviewFormAndIframe
								live={names.live}
								token={names.token}
								handleSuccess={handleSuccess}
							/>
						) : (
							<S.LoadingContainer>
								<Alert data={{ type: "working", text: "" }} />
							</S.LoadingContainer>
						)}
					</>
				)}
			</>
		</div>
	);
};

export default Review;
